/**
 * ZBA Social Booking — Translations
 * Languages: de (Deutsch), uk (Українська), ru (Русский)
 */

export const T = {
  de: {
    // Language selector
    langSelect: {
      title: 'Sprache wählen',
      subtitle: 'Bitte wähle deine bevorzugte Sprache',
      de: 'Deutsch',
      uk: 'Ukrainisch',
      ru: 'Russisch',
      continue: 'Weiter',
    },
    // Qualification
    qual: {
      step: 'Schritt 1 von 2',
      title: 'Kurze Fragen vorab',
      subtitle: 'Damit wir uns optimal auf das Gespräch vorbereiten können.',
      privacy: {
        label: 'Datenschutz',
        text: 'Ich bin damit einverstanden, dass meine Daten zur Bearbeitung meiner Anfrage gespeichert und verarbeitet werden. Die Daten werden ausschließlich für die Terminverwaltung genutzt und nicht an Dritte weitergegeben. Weitere Informationen findest du in unserer',
        link: 'Datenschutzerklärung',
        required: 'Bitte stimme der Datenschutzerklärung zu.',
      },
      german: {
        label: 'Deutschkenntnisse',
        question: 'Sprichst du Deutsch gut genug, um an einem Kurs teilzunehmen und diesen zu verstehen?',
        yes: 'Ja, mein Deutsch ist ausreichend',
        no: 'Nein, ich benötige Unterstützung',
      },
      license: {
        label: 'Führerschein',
        question: 'Besitzt du einen Führerschein der Klasse B (PKW)?',
        yes: 'Ja, ich habe einen Führerschein Klasse B',
        no: 'Nein, ich habe keinen Führerschein Klasse B',
      },
      next: 'Weiter zum Termin',
    },
    booking: {
      typeTitle: 'Beratungsart wählen',
      typeSub: 'Wie möchtest du beraten werden?',
      onsiteLabel: 'Vor-Ort-Beratung',
      onsiteDesc: 'Persönliches Gespräch · Kruppstraße 41-45, 42489 Wülfrath',
      phoneLabel: 'Telefonberatung',
      phoneDesc: 'Bequem von zu Hause aus. Für erste Fragen und schnelle Orientierung.',
      recommended: 'EMPFOHLEN',
      free: '✓ 100% kostenlos - keine Verpflichtung',
      calTitle: 'Termin wählen',
      calSub: 'Wähle einen verfügbaren Tag',
      calOnsiteSub: 'Vor-Ort-Beratung · Kruppstraße 41-45, 42489 Wülfrath',
      calPhoneSub: 'Telefonberatung',
    },
    steps: {
      time: {
        title: 'Uhrzeit wählen', selectedDay: 'Gewählter Tag',
        morning: '☀️ Vormittag', afternoon: '🌤️ Nachmittag', uhr: 'Uhr',
        noSlots: 'Keine Termine verfügbar', noSlotsHint: 'Bitte wähle einen anderen Tag.', back: 'Zurück',
      },
      contact: {
        title: 'Deine Kontaktdaten', subtitle: 'Alle mit * markierten Felder sind Pflichtfelder.',
        vorname: 'Vorname *', nachname: 'Nachname *', email: 'E-Mail-Adresse *',
        telefon: 'Telefonnummer *', wohnort: 'Wohnort (optional)',
        back: 'Zurück', next: 'Zur Zusammenfassung',
        errVorname: 'Vorname ist erforderlich', errNachname: 'Nachname ist erforderlich',
        errEmail: 'E-Mail ist erforderlich', errTelefon: 'Telefonnummer ist erforderlich',
      },
      summary: {
        title: 'Zusammenfassung', appointment: 'Dein Termin', yourData: 'Deine Angaben',
        back: 'Zurück', book: 'Jetzt buchen ✓',
        conflict: 'Dieser Termin wurde soeben vergeben. Bitte wähle einen anderen Zeitslot.',
        onsiteLabel: 'Vor-Ort-Beratung', phoneLabel: 'Telefonberatung', uhr: 'Uhr', edit: 'Ändern',
      },
      success: {
        badge: '✓ Kostenlos & unverbindlich', title: 'Termin bestätigt! 🎉',
        sub: 'Wir freuen uns auf das Gespräch mit dir.', detailsTitle: 'DEINE TERMINDETAILS',
        onsiteLabel: 'Vor-Ort-Beratung', phoneLabel: 'Telefonberatung', uhr: 'Uhr',
        emailSent: 'Eine Bestätigungs-E-Mail wurde an', emailSent2: 'gesendet.', ref: 'BUCHUNGSREFERENZ',
      },
    },
    type: {
      step: 'Schritt 2 von 7',
      title: 'Beratungsart wählen',
      subtitle: 'Wie möchtest du beraten werden?',
    },
    success: {
      title: 'Termin bestätigt!',
      sub: 'Vielen Dank',
      emailSent: 'Eine Bestätigungs-E-Mail wurde an',
      emailSent2: 'gesendet.',
    },
  },

  inst: {
    langSelect: { title: 'Sprache', subtitle: '' },
    steps: {
      contact: {
        title: 'Kontaktdaten', badge: 'Schritt 4 von 6',
        vorname: 'Vorname', nachname: 'Nachname', telefon: 'Telefon', email: 'E-Mail',
        next: 'Weiter', back: 'Zurück',
        errorRequired: 'Bitte alle Pflichtfelder ausfüllen.',
        errorEmail: 'Bitte gültige E-Mail eingeben.',
      },
      calendar: {
        title: 'Termin wählen', badge: 'Schritt 2 von 6',
      },
      timeslot: {
        title: 'Uhrzeit wählen', badge: 'Schritt 3 von 6',
      },
      summary: {
        title: 'Zusammenfassung', appointment: 'Ihr Termin', yourData: 'Ihre Angaben',
        back: 'Zurück', book: 'Jetzt buchen ✓',
        conflict: 'Dieser Termin wurde soeben vergeben. Bitte wählen Sie einen anderen Zeitslot.',
        onsiteLabel: 'Vor-Ort-Gespräch', phoneLabel: 'Telefonat', uhr: 'Uhr', edit: 'Ändern',
      },
      success: {
        badge: '✓ Termin bestätigt', title: 'Termin bestätigt!',
        sub: 'Wir freuen uns auf das Gespräch mit Ihnen.', detailsTitle: 'IHRE TERMINDETAILS',
        onsiteLabel: 'Vor-Ort-Gespräch', phoneLabel: 'Telefonat', uhr: 'Uhr',
        emailSent: 'Eine Bestätigungs-E-Mail wurde an', emailSent2: 'gesendet.', ref: 'REFERENZ',
      },
    },
    type: {
      step: 'Schritt 1 von 6',
      title: 'Gesprächsart wählen',
      subtitle: 'Wie möchten Sie den Termin wahrnehmen?',
    },
    success: {
      title: 'Termin bestätigt!',
      sub: 'Vielen Dank',
      emailSent: 'Eine Bestätigungs-E-Mail wurde an',
      emailSent2: 'gesendet.',
    },
  },

  uk: {
    langSelect: {
      title: 'Оберіть мову',
      subtitle: 'Будь ласка, оберіть мову для продовження',
      de: 'Німецька',
      uk: 'Українська',
      ru: 'Російська',
      continue: 'Продовжити',
    },
    qual: {
      step: 'Крок 1 з 2',
      title: 'Кілька запитань',
      subtitle: 'Щоб ми могли якнайкраще підготуватися до розмови.',
      privacy: {
        label: 'Захист даних',
        text: 'Я погоджуюсь із тим, що мої дані зберігаються та обробляються для розгляду моєї заявки. Дані використовуються виключно для управління зустрічами і не передаються третім особам. Детальніше — у нашій',
        link: 'Політиці конфіденційності',
        required: 'Будь ласка, погодьтеся з Політикою конфіденційності.',
      },
      german: {
        label: 'Знання німецької',
        question: 'Чи достатньо добре ти розмовляєш німецькою, щоб брати участь у курсі та розуміти його?',
        yes: 'Так, моєї німецької достатньо',
        no: 'Ні, мені потрібна підтримка',
      },
      license: {
        label: 'Водійське посвідчення',
        question: 'Чи маєш ти водійське посвідчення категорії B (легковий автомобіль)?',
        yes: 'Так, у мене є посвідчення категорії B',
        no: 'Ні, водійського посвідчення категорії B немає',
      },
      next: 'Далі до запису',
    },
    booking: {
      typeTitle: 'Вибір типу консультації',
      typeSub: 'Як ти хочеш отримати консультацію?',
      onsiteLabel: 'Консультація особисто',
      onsiteDesc: 'Особиста зустріч · Kruppstraße 41-45, 42489 Wülfrath',
      phoneLabel: 'Телефонна консультація',
      phoneDesc: 'Зручно з дому. Для перших запитань та швидкої орієнтації.',
      recommended: 'РЕКОМЕНДОВАНО',
      free: '✓ 100% безкоштовно - без зобов\u2019язань',
      calTitle: 'Вибір дати',
      calSub: 'Оберіть доступний день',
      calOnsiteSub: 'Консультація особисто · Kruppstraße 41-45, 42489 Wülfrath',
      calPhoneSub: 'Телефонна консультація',
    },
    steps: {
      time: {
        title: 'Вибір часу',
        selectedDay: 'Обраний день',
        morning: '☀️ Ранок',
        afternoon: '🌤️ День',
        uhr: '',
        noSlots: 'Немає доступних записів',
        noSlotsHint: 'Будь ласка, оберіть інший день.',
        back: 'Назад',
      },
      contact: {
        title: 'Ваші дані',
        subtitle: 'Щоб ми могли з вами зв\'язатися.',
        vorname: 'Ім\'я *',
        nachname: 'Прізвище *',
        email: 'Електронна пошта *',
        telefon: 'Номер телефону *',
        wohnort: 'Місто (необов\'язково)',
        back: 'Назад',
        next: 'До підсумку',
        errVorname: 'Ім\'я обов\'язкове',
        errNachname: 'Прізвище обов\'язкове',
        errEmail: 'Електронна пошта обов\'язкова',
        errTelefon: 'Номер телефону обов\'язковий',
      },
      summary: {
        title: 'Підсумок',
        appointment: 'Ваш запис',
        yourData: 'Ваші дані',
        back: 'Назад',
        book: 'Записатися ✓',
        conflict: 'Цей час щойно зайнятий. Оберіть інший.',
        onsiteLabel: 'Консультація особисто',
        phoneLabel: 'Телефонна консультація',
        uhr: '',
        edit: 'Змінити',
      },
      success: {
        badge: '✓ Безкоштовно та без зобов’язань',
        title: 'Запис підтверджено! 🎉',
        sub: 'Ми з нетерпінням чекаємо на розмову з вами.',
        detailsTitle: 'ДЕТАЛІ ЗАПИСУ',
        onsiteLabel: 'Консультація особисто',
        phoneLabel: 'Телефонна консультація',
        uhr: '',
        emailSent: 'Лист із підтвердженням надіслано на',
        emailSent2: '.',
        ref: 'НОМЕР ЗАПИСУ',
      },
    },
    type: {
      step: 'Крок 2 з 7',
      title: 'Вибір типу консультації',
      subtitle: 'Як ти хочеш отримати консультацію?',
    },
    success: {
      title: 'Зустріч підтверджена!',
      sub: 'Дякуємо',
      emailSent: 'Лист із підтвердженням надіслано на адресу',
      emailSent2: '.',
    },
  },

  ru: {
    langSelect: {
      title: 'Выберите язык',
      subtitle: 'Пожалуйста, выберите предпочитаемый язык',
      de: 'Немецкий',
      uk: 'Украинский',
      ru: 'Русский',
      continue: 'Продолжить',
    },
    qual: {
      step: 'Шаг 1 из 2',
      title: 'Несколько вопросов',
      subtitle: 'Чтобы мы могли наилучшим образом подготовиться к разговору.',
      privacy: {
        label: 'Защита данных',
        text: 'Я согласен(а) с тем, что мои данные сохраняются и обрабатываются для рассмотрения моей заявки. Данные используются исключительно для управления записями и не передаются третьим лицам. Подробнее — в нашей',
        link: 'Политике конфиденциальности',
        required: 'Пожалуйста, примите Политику конфиденциальности.',
      },
      german: {
        label: 'Знание немецкого',
        question: 'Достаточно ли хорошо ты говоришь по-немецки, чтобы участвовать в курсе и понимать его?',
        yes: 'Да, моего немецкого достаточно',
        no: 'Нет, мне нужна поддержка',
      },
      license: {
        label: 'Водительское удостоверение',
        question: 'Есть ли у тебя водительское удостоверение категории B (легковой автомобиль)?',
        yes: 'Да, у меня есть категория B',
        no: 'Нет, водительского удостоверения категории B нет',
      },
      next: 'Далее к записи',
    },
    booking: {
      typeTitle: 'Выбор типа консультации',
      typeSub: 'Как ты хочешь получить консультацию?',
      onsiteLabel: 'Консультация лично',
      onsiteDesc: 'Личная встреча · Kruppstraße 41-45, 42489 Wülfrath',
      phoneLabel: 'Телефонная консультация',
      phoneDesc: 'Удобно из дома. Для первых вопросов и быстрой ориентации.',
      recommended: 'РЕКОМЕНДУЕТСЯ',
      free: '✓ 100% бесплатно - без обязательств',
      calTitle: 'Выбор даты',
      calSub: 'Выберите доступный день',
      calOnsiteSub: 'Консультация лично · Kruppstraße 41-45, 42489 Wülfrath',
      calPhoneSub: 'Телефонная консультация',
    },
    steps: {
      time: {
        title: 'Выбор времени',
        selectedDay: 'Выбранный день',
        morning: '☀️ Утро',
        afternoon: '🌤️ День',
        uhr: '',
        noSlots: 'Нет доступных записей',
        noSlotsHint: 'Пожалуйста, выберите другой день.',
        back: 'Назад',
      },
      contact: {
        title: 'Ваши данные',
        subtitle: 'Чтобы мы могли с вами связаться.',
        vorname: 'Имя *',
        nachname: 'Фамилия *',
        email: 'Электронная почта *',
        telefon: 'Номер телефона *',
        wohnort: 'Город (необязательно)',
        back: 'Назад',
        next: 'К итогу',
        errVorname: 'Имя обязательно',
        errNachname: 'Фамилия обязательна',
        errEmail: 'Электронная почта обязательна',
        errTelefon: 'Номер телефона обязателен',
      },
      summary: {
        title: 'Итог',
        appointment: 'Ваша запись',
        yourData: 'Ваши данные',
        back: 'Назад',
        book: 'Записаться ✓',
        conflict: 'Это время только что занято. Выберите другое.',
        onsiteLabel: 'Консультация лично',
        phoneLabel: 'Телефонная консультация',
        uhr: '',
        edit: 'Изменить',
      },
      success: {
        badge: '✓ Бесплатно и без обязательств',
        title: 'Запись подтверждена! 🎉',
        sub: 'Мы с нетерпением ждём разговора с вами.',
        detailsTitle: 'ДЕТАЛИ ЗАПИСИ',
        onsiteLabel: 'Консультация лично',
        phoneLabel: 'Телефонная консультация',
        uhr: '',
        emailSent: 'Письмо с подтверждением отправлено на',
        emailSent2: '.',
        ref: 'НОМЕР ЗАПИСИ',
      },
    },
    type: {
      step: 'Шаг 2 из 7',
      title: 'Выбор типа консультации',
      subtitle: 'Как ты хочешь получить консультацию?',
    },
    success: {
      title: 'Встреча подтверждена!',
      sub: 'Спасибо',
      emailSent: 'Письмо с подтверждением отправлено на адрес',
      emailSent2: '.',
    },
  },
};

export const SUPPORTED_LANGS = ['de', 'uk', 'ru'];
export const LANG_NAMES = { de: 'Deutsch', uk: 'Українська', ru: 'Русский' };
export const LANG_FLAGS = { de: '🇩🇪', uk: '🇺🇦', ru: '🇷🇺' };
